<template>
  <div
    :class="
      $twMerge(
        'relative px-6 lg:px-10 py-12 lg:py-16 transition-all duration-700 shadow-md max-lg:pt-36 dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.7)]',
        imgPosition === 'left'
          ? 'lg:pl-28 lg:flex-row-reverse lg:[box-shadow:-25px_0_30px_0_rgba(0,0,0,.18)]'
          : 'lg:pr-28 lg:[box-shadow:25px_0_30px_0_rgba(0,0,0,.18)]',
        appendClass
      )
    "
  >
    <!-- Icon -->
    <div
      :class="
        $twMerge(
          'size-24 absolute top-4 lg:top-[50px] grid place-content-center ',
          imgPosition === 'left'
            ? 'left-4 lg:-left-8 top-8'
            : 'top-8 left-4 lg:-right-8 lg:left-auto',
          iconAppendClass
            ? 'bg-[#FE312A]'
            : 'bg-[image:var(--bg-technologies-gradient)]'
        )
      "
    >
      <NuxtImg
        :src="icon"
        :alt="alt"
        width="39"
        height="57"
        loading="lazy"
        format="webp"
      />
    </div>

    <!-- Content -->
    <div>
      <p class="text-sm font-medium mb-1">{{ subtitle }}</p>
      <p
        class="text-2xl lg:text-4xl font-medium leading-snug mb-2"
        v-html="title"
      />
      <hr
        class="h-1 w-10 border-0 mt-2.5 mb-6 lg:mb-8 bg-[image:var(--bg-technologies-gradient)]"
      />
      <div class="leading-relaxed mb-6 lg:mb-8" v-html="description"></div>

      <!-- CTA -->
      <WrButton
        container-class="mt-2"
        append-class="flex items-center gap-2"
        :link="link"
        @click="handleClick"
      >
        {{ buttonText }}
      </WrButton>
    </div>
    <WrContactFormPopup
      v-if="visible"
      :isOpen="visible"
      @close="visible = false"
      class="z-30"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
const { $twMerge } = useNuxtApp();
const WrContactFormPopup = defineAsyncComponent(
  () => import("./WrContactFormPopup.vue")
);

interface CardCTAProps {
  icon?: string;
  alt?: string;
  subtitle?: string;
  title?: string;
  description?: string;
  buttonText?: string;
  imgPosition?: "left" | "right";
  appendClass?: string;
  iconAppendClass?: Boolean | String;
  link?: string;
}

const props = withDefaults(defineProps<CardCTAProps>(), {
  icon: "/images/icons/icon-reactnative-cross-platform.webp",
  alt: "Adonis Development Services",
  subtitle: "Work with our Adonis experts",
  title:
    "Have a brilliant idea that you would like to see turned into a reality?",
  description:
    "Building on years of project management experience and proven expertise in the design and development fields, we've created an approach to development that cuts through bureaucratic red tape and puts your project on the fast track to success.",
  buttonText: `Let's work together`,
  imgPosition: "right",
  appendClass: "",
  iconAppendClass: false,
});

const visible = ref(false);

const openModal = () => {
  visible.value = true;
};

const handleClick = () => {
  if (!props.link) openModal();
};
</script>
